import type { SVGProps } from 'react';
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlSpace="preserve" width={props.width || '1em'} height={props.height || '1em'} {...props} viewBox="0 0 256 256">
		<g
			style={{
				stroke: 'none',
				strokeWidth: 0,
				strokeDasharray: 'none',
				strokeLinecap: 'butt',
				strokeLinejoin: 'miter',
				strokeMiterlimit: 10,
				fill: 'none',
				fillRule: 'nonzero',
				opacity: 1,
			}}
		>
			<path
				d="M65.75 90a3.499 3.499 0 0 0 2.475-5.974L29.2 45 68.225 5.975a3.5 3.5 0 1 0-4.95-4.95l-41.5 41.5a3.499 3.499 0 0 0 0 4.949l41.5 41.5A3.487 3.487 0 0 0 65.75 90z"
				style={{
					stroke: 'none',
					strokeWidth: 1,
					strokeDasharray: 'none',
					strokeLinecap: 'butt',
					strokeLinejoin: 'miter',
					strokeMiterlimit: 10,
					fill: props.color || 'var(--icon)',
					fillRule: 'nonzero',
					opacity: 1,
				}}
				transform="matrix(2.81 0 0 2.81 1.407 1.407)"
			/>
		</g>
	</svg>
);
export default SvgComponent;
